// import ablukaImg from '../img/abluka.png';
import false9Img from '../img/false9.png';

/* ─────────────────────────────────────────────────────────────
   ABLUKA — yorum satırına alındı (artık kullanılmıyor)
   ─────────────────────────────────────────────────────────────
export const heroData = [
  {
    id: 1,
    name: 'Abluka',
    slug: 'abluka',
    tagline: 'Alanı Kapat, Zekâyı Konuştur',
    imageSrc: ablukaImg,
    shortDescription:
      'Rakibinin taşını hareket edemez hale getir. 7×7 tahtada derin strateji ve taktik mücadelesi.',
    description: `🔒 ABLUKA – Alanı Kapat, Zekâyı Konuştur
Abluka, iki kişiyle oynanan, strateji odaklı ve taktiksel derinliği yüksek bir zeka oyunudur. Her hamlede rakibinizin hareket alanını daraltın, düşünme becerilerinizi sergileyin ve taşını kıstırarak oyunu kazanın!

🎯 Amaç
Oyundaki nihai hedef, rakibinizin taşını hareket edemez hale getirmek. Her hamlede sadece ilerlemeyi değil, engellemeyi de planlayarak rakibinizi blok altına alın.

🧩 Oyun İçeriği
- 1 adet 7x7 karelik oyun tahtası
- 2 adet ana taş (siyah ve beyaz)
- 48 adet engel taşı (ortak kullanım)

📜 Oyun Kuralları
1. Başlangıç
Oyuncular, ana taşlarını tahtanın ortasında belirtilen karelere yerleştirir.
Siyah taşla oynayan oyuncu oyuna başlar.

2. Hamle Sırası
Her oyuncu sırası geldiğinde şu iki adımı uygular:
- Ana taşını yatay, dikey veya çapraz doğrultuda boş bir kareye taşır.
- Ardından bir engel taşını, tahtada dilediği boş kareye yerleştirir.
⚠️ Taşların veya engellerin üzerinden atlama yapılmaz. Yerleştirilen engeller bir daha hareket ettirilemez.

3. Oyun Bitişi
Oyunculardan biri hiçbir yöne hareket edemediğinde, oyun sona erer.
Hareket edemeyen oyuncu mağlup sayılır.

🧠 Neler Gelişir?
- Stratejik düşünme ve planlama
- Görsel-zihinsel koordinasyon
- Rakibin hamlelerini öngörebilme becerisi
- Problem çözme ve sabır yönetimi`,
    features: [
      '2 oyunculu çevrimiçi mod',
      'Tek oyunculu mod',
      'Canlı sıralama tablosu',
      'Profil sistemi',
      '7×7 strateji tahtası',
      'Gerçek zamanlı hamle takibi',
    ],
    genre: 'Strategy',
    platforms: ['iOS', 'Android'],
    status: 'Yakında',
    releaseDate: 'Yakında — 2026',
    developer: 'Harman Play',
    publisher: 'Harman Play',
    ageRating: '7+',
    isFeatured: true,
    tags: ['Strateji', 'Çok Oyunculu', 'Bulmaca', '2 Oyuncu'],
  },
];
   ───────────────────────────────────────────────────────────── */

export const heroData = [
  {
    id: 1,
    name: 'False9',
    slug: 'false9',
    tagline: 'Sahanın Gizli Numarası',
    imageSrc: false9Img,
    playUrl: 'https://harmanplay.com/false9/gizli-oyuncu',
    shortDescription:
      'Sahte santrforunla savunmayı şaşırt, boşlukları bul ve gol için doğru hamleyi yap. Hızlı tempolu futbol oyunu.',
    description: `⚽ FALSE9 – Sahanın Gizli Numarası
False9, futbolun en kurnaz pozisyonundan ilham alan, futbol zekâsı ve refleksi bir araya getiren bir oyundur. Rakibin savunma düzenini boz, oyunu yönlendir ve doğru anı kollayarak filelere gönder!

🎯 Amaç
Sahte santrfor (false nine) gibi düşün: beklenmedik alanlara açıl, savunucuları yerinden et ve takımına gol fırsatları yarat. Her maçta skoru öne geçir.

🧩 Oyun İçeriği
- Dinamik saha ve gerçekçi top fiziği
- Yapay zekâ destekli rakip savunma
- Çeşitli pas, şut ve dripling mekanikleri

📜 Nasıl Oynanır?
1. Oyunu başlat ve sahaya çık.
2. Topu yönlendir, boşlukları gör ve pas/şut için doğru zamanı yakala.
3. Süre dolmadan rakipten daha çok gol at.

🧠 Neler Gelişir?
- Hızlı karar verme ve konumlanma
- Oyun kurma ve pas tercihleri
- El-göz koordinasyonu ve refleks`,
    features: [
      'Tek oyunculu kampanya',
      'Hızlı maç modu',
      'Yapay zekâ rakip',
      'Skor tablosu',
      'Gerçekçi top fiziği',
      'Kolay kontroller',
    ],
    genre: 'Sports',
    platforms: ['iOS', 'Android'],
    status: 'Yakında',
    releaseDate: 'Yakında — 2026',
    developer: 'Harman Play',
    publisher: 'Harman Play',
    ageRating: '7+',
    isFeatured: true,
    tags: ['Futbol', 'Refleks', 'Spor'],
  },
];

export const categories = [
  { id: 1, name: 'Futbol', urlParamName: 'sports' },
];
